import { render, staticRenderFns } from "./EchartItem.vue?vue&type=template&id=28d424bb"
import script from "./EchartItem.vue?vue&type=script&lang=js"
export * from "./EchartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports